import PageHero from "../components/PageHero";
import SmartLink from "../components/SmartLink";
import TrustBar from "../components/TrustBar";
import { ArrowRightIcon, CheckIcon } from "../components/Icons";
import { about } from "../lib/content";

export default function AboutPage() {
  return (
    <>
      <PageHero
        eyebrow="About Qost.ai"
        title={about.pageTitle}
        intro={about.pageIntro}
        actions={
          <SmartLink href={about.cta.href} className="btn-primary">
            {about.cta.label}
            <ArrowRightIcon />
          </SmartLink>
        }
      />

      {/* Cloudlaya: the parent company and where the expertise comes from. */}
      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">Cloudlaya</span>
            <h2 className="h-section mt-4">{about.cloudlayaHeading}</h2>
          </div>

          <div className="mt-8 max-w-3xl space-y-4">
            {about.cloudlayaStory.map((paragraph) => (
              <p key={paragraph} className="text-base leading-relaxed text-ink-muted">
                {paragraph}
              </p>
            ))}
          </div>

          <dl className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {about.stats.map((stat) => (
              <div key={stat.label} className="card p-6 shadow-card">
                <dt className="text-3xl font-extrabold tracking-tight text-brand-600">
                  {stat.value}
                </dt>
                <dd className="mt-2 text-sm font-medium text-ink-muted">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </section>

      {/* Mission */}
      <section className="section-pad bg-ink-soft">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">Purpose</span>
            <h2 className="h-section mt-4">{about.missionHeading}</h2>
          </div>
          <div className="mt-8 max-w-3xl space-y-4">
            {about.mission.map((paragraph) => (
              <p key={paragraph} className="text-base leading-relaxed text-ink-muted">
                {paragraph}
              </p>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section-pad bg-white">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">How we work</span>
            <h2 className="h-section mt-4">{about.valuesHeading}</h2>
            <p className="lead">{about.valuesIntro}</p>
          </div>

          <div className="mt-12 grid gap-6 lg:grid-cols-3">
            {about.values.map((value) => (
              <div key={value.title} className="card p-7 shadow-card">
                <h3 className="text-base font-semibold text-ink">{value.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ink-muted">{value.body}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cloudlaya services */}
      <section className="section-pad bg-ink-soft">
        <div className="container-page">
          <div className="max-w-2xl">
            <span className="eyebrow">Cloudlaya ecosystem</span>
            <h2 className="h-section mt-4">{about.partnerHeading}</h2>
            <p className="lead">{about.servicesIntro}</p>
          </div>

          <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {about.services.map((service) => (
              <li key={service} className="card flex items-center gap-3 p-5 shadow-card">
                <span className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-50 text-brand-600">
                  <CheckIcon />
                </span>
                <span className="text-sm font-medium text-ink">{service}</span>
              </li>
            ))}
          </ul>

          <SmartLink href={about.cta.href} className="btn-ghost mt-10">
            Explore all Cloudlaya services
            <ArrowRightIcon />
          </SmartLink>
        </div>
      </section>

      <TrustBar />
    </>
  );
}
